import type { Strings } from '../index.ts';
import { channel } from './channel.ts';
import { comments } from './comments.ts';
import { feed } from './feed.ts';
import { gated } from './gated.ts';
import { hashtag } from './hashtag.ts';
import { history } from './history.ts';
import { listing } from './listing.ts';
import { login } from './login.ts';
import { playlist } from './playlist.ts';
import { playlists } from './playlists.ts';
import { problem } from './problem.ts';
import { queue } from './queue.ts';
import { richText } from './richText.ts';
import { resolve } from './resolve.ts';
import { search } from './search.ts';
import { settings } from './settings.ts';
import { shell } from './shell.ts';
import { sponsorBlock } from './sponsorBlock.ts';
import { subscriptions } from './subscriptions.ts';
import { tabs } from './tabs.ts';
import { watch } from './watch.ts';

/**
 * **Deutsch** — die zweite Sprache, und der erste Beweis, dass `Strings` als Vertrag trägt.
 *
 * Kein `as const` hier und in keiner Datei daneben: der englische Katalog trägt es, weil er den *Typ*
 * hergibt, und dieser hier wird gegen den Typ geprüft. Jede Datei ist einzeln als `Strings['<Abschnitt>']`
 * annotiert und nicht erst hier gemeinsam, damit ein fehlender Schlüssel in der Datei gemeldet wird, in
 * der er fehlt, statt in einem Fehler über den ganzen Baum.
 *
 * Was bei der Übersetzung entschieden wurde und in jeder Datei gilt:
 *
 * - **„du“, klein.** Die Ansprache deutscher Medien-Apps, und sie passt zum direkten Ton des englischen
 *   Originals. Sie zieht durch fast jeden Satz, ein Wechsel ist also keine Kleinigkeit.
 * - **Deutsche Anführungszeichen „…“** überall, wo das Englische `“…”` setzt.
 * - **Keine Geviertstriche und keine Semikolons**, wie im Hausstil. Halbgeviertstriche bleiben in Spannen
 *   (`4–20 Minuten`, `Name A–Z`).
 * - **Zusammengesetzte Substantive statt Bindestrichketten**, außer wo ein Eigenname darin steht
 *   („YouTube-Videoplayer“, „Beliebt-Feed“).
 * - Feste Begriffe: Instanz, Kanal, Playlist, Abo, Wiedergabeverlauf, Sitzung, Konto, Tonspur, Untertitel,
 *   Vorschaubild, Aufrufe, Abonnenten. Sie sind über alle Dateien gleich gehalten.
 *
 * Was **nicht** übersetzt ist, weil es kein Wort ist: `LIVE` (das Abzeichen in der Ecke eines
 * Vorschaubilds), Produktnamen (SponsorBlock, DeArrow, PeerTube, Return YouTube Dislike, Invidious),
 * Formatkürzel (`HD`, `4K`, `HDR`, `3D`, `360°`, `CC`) und `Autoplay`, das im Deutschen ebenso gilt.
 */
export const de: Strings = {
  channel,
  comments,
  feed,
  gated,
  hashtag,
  history,
  listing,
  login,
  playlist,
  playlists,
  problem,
  queue,
  richText,
  resolve,
  search,
  settings,
  shell,
  sponsorBlock,
  subscriptions,
  tabs,
  watch,
};
